// profile API
import ajax from './_ajax';

const api = {};
api.invoiceGetAll = function () {
  return ajax.get('/api/Invoice/GetAll');
};
api.invoiceAdd = function (data) {
  return ajax.post('/api/Invoice/Add', data);
};
api.invoiceEdit = function (data) {
  return ajax.post('/api/Invoice/Edit', data);
};
api.invoiceDelete = function (data) {
  console.log(data);
  return ajax.post('/api/Invoice/Delete', data);
};
api.invoiceSetDefault = function (data) {
  return ajax.post('/api/Invoice/SetDefault', data);
};
api.cancelOrderProcess = function (data) {
  return ajax.post('/api/OrderProcess/Cancel', data);
};
api.wishlistGetAll = function (data) {
  return ajax.post('/api/Wishlist/GetAll', data);
};
api.getPagedOrders = function (data) {
  return ajax.post('/api/Order/GetPagedOrders', data);
};
api.queryKuaiDiInfo = function (data) {
  return ajax.get('/api/KuaiDi100/QueryKuaiDiInfo?com=' + data.com + '&num=' + data.num + '&phone=' + data.phone);
};
api.deleteWishlistInMyFavorite = function (data) {
  return ajax.post('/api/Wishlist/Delete', data);
};
api.orderReceiveItems = function (data) {
  return ajax.post('/api/order/ReceiveItems', data);
};
api.orderRefund = function (data) {
  return ajax.post('/api/Order/Refund', data);
};
api.getCreditLinesHistory = function (data) {
  return ajax.post('/api/CreditLines/CreditLinesHistory', data);
};
api.getLeftCreditLinesAmount = function () {
  return ajax.get('/api/CreditLines/GetLeftCreditLinesAmount');
};
api.getOrderRefundInfo = function (orderItemId) {
  return ajax.get('/api/Order/RefundInfo?orderItemId=' + orderItemId);
};
export default api;



// WEBPACK FOOTER //
// ./src/api/profileApi.js